import { useLocation, useNavigate } from 'react-router-dom';
import { List, ListItemText } from 'components/ui';
import { ProbelistInspectionsIcon, ProbelistItemsIcon, ProbelistObjectsIcon, ProbelistSettingsIcon, ProbelistTemplatesIcon, ProbelistDashboardIcon } from 'components/uiIcons';
import { SideMenuDrawer, ListMenuItem } from 'components/styles_components/menu';
import { FormattedMessage } from 'react-intl';
import {
  InspectionsLink,
  InspectionSubjectsLink,
  PlacesLink,
  TemplatesLink,
  DashboardLink,
  SpaceShowLink,
} from 'utils/link';
import { useMenu } from 'contexts/menu';
import { useSpace } from 'contexts/space';

import useMobile from 'hooks/use_mobile';
import useUserHeader from 'hooks/use_user_header';

const SideMenu = () => {
  const location = useLocation();
  const isMobile = useMobile();
  const navigate = useNavigate();
  const { sidebarVisible, setSidebarVisible } = useMenu();
  const { user } = useUserHeader();
  const fullWidth = isMobile && sidebarVisible;
  const { currentSpaceId } = useSpace();

  const onItemClick = (link) => {
    if (isMobile) {
      setSidebarVisible(false);
    }
    navigate(link);
  };

  const linkItems = () => {
    let items = {};
    items[DashboardLink()] = 'navbar.home';

    if (currentSpaceId) {
      items[PlacesLink()] = 'navbar.places';
      items[InspectionSubjectsLink()] = 'navbar.inspection_subjects';
      items[InspectionsLink()] = 'navbar.inspections';
      if (user.adminRole) {
        items[TemplatesLink()] = 'navbar.templates';
        items[SpaceShowLink()] = 'navbar.space';
      }
    }
    return items;
  };

  const listIcons = () => {
    let icons = {};
    icons[DashboardLink()] = <ProbelistDashboardIcon aria-hidden="true" />;
    icons[PlacesLink()] = <ProbelistObjectsIcon aria-hidden="true" />;
    icons[InspectionSubjectsLink()] = <ProbelistItemsIcon aria-hidden="true" />;
    icons[InspectionsLink()] = <ProbelistInspectionsIcon aria-hidden="true" />;
    if (user.adminRole) {
      icons[TemplatesLink()] = <ProbelistTemplatesIcon aria-hidden="true" />;
      icons[SpaceShowLink()] = <ProbelistSettingsIcon aria-hidden="true" />;
    }
    return icons;
  }

  const list = () => {
    let items = linkItems();
    let icons = listIcons();

    return Object.keys(items).map((link) => {
      return item(link, items[link], icons[link]);
    });
  };

  const item = (link, translationId, icon = null) => {
    return (
      <ListMenuItem
        key={link}
        onClick={() => onItemClick(link)}
        selected={location.pathname === link || location.pathname.startsWith(`${link}/`)}
      >
        <span className="pre" />
        {icon}
        <ListItemText>
          <FormattedMessage id={translationId} />
        </ListItemText>
      </ListMenuItem>
    );
  };

  return (
    <SideMenuDrawer
      id="side-menu"
      variant="persistent"
      className={fullWidth ? 'full-width' : ''}
      open={sidebarVisible}
    >
      <List component="nav" aria-label="Main navigation">{list()}</List>
    </SideMenuDrawer>
  );
};

export default SideMenu;
